// @flow
import * as React from 'react';
import { QuizStepNumber, QuizStepHeading } from '../app/features';
import { ZipSelectorCompact } from '@coverright/features/zip-selector/zip-selector-compact';
import { useFormik } from 'formik';
import {
  getStoredUser,
  setStoredUser,
} from '@coverright/utils';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { getRoute } from '../app/router';
import { motion } from 'framer-motion';
import { Button, Typography } from '@mui/material';
import { ComponentProps, useRef, useState } from 'react';

type Location = Parameters<ComponentProps<typeof ZipSelectorCompact>['onChange']>[0]


const schemaFields: any = {
  zip: yup.string().required('Zip is required'),
  county: yup.string().required('County name is required'),
  state: yup.string(),
};

export const Zip = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const navigate = useNavigate();

  const [isValid, setIsValid] = useState(!!getStoredUser()?.zip && !!getStoredUser()?.countyName);
  const formik = useFormik({
    initialValues: {
      zip: getStoredUser()?.zip,
      county: getStoredUser()?.countyName,
      state: getStoredUser()?.state,
    },
    validationSchema: yup.object(schemaFields),
    onSubmit: (values) => {
      if (formik.isValid) {
        setStoredUser({
          ...getStoredUser(),
          zip: values.zip,
          countyName: values.county,
          state: values.state
        });
        navigate(getRoute('basicInfo'));
      }
    },
    validateOnChange: true,
    validateOnMount: true,
  });

  const onChange = (data: Location) => {
    formik.setValues(data);
    setIsValid(!!data.zip && !!data.county)
    if (data.zip && data.county) setTimeout(() => buttonRef.current?.focus(), 0);
  }

  return (
    <>
      <QuizStepNumber step={1} completed={isValid} />

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, delay: 0.1, ease: 'easeOut' }}
      >
        <QuizStepHeading variant={'h1'} sx={{mb: {xs: 1, sm: 3} }} tabIndex={-1}>What's your ZIP code?</QuizStepHeading>
        <ZipSelectorCompact onChange={onChange}
                            inputProps={{
                              autoFocus: true,
                              label: '',
                              error: formik.touched.zip && Boolean(formik.errors.zip) || formik.touched.county && Boolean(formik.errors.county),
                              helperText: formik.touched.zip && formik.errors.zip || formik.touched.county && formik.errors.county
                            }}
                            zip={formik.values.zip || ''}
                            county={formik.values.county || ''} />
        <Typography mt={1.5} color={'text.secondary'}>We will search for plans in your zipcode.</Typography>

        <Button ref={buttonRef} variant={'contained'}
                sx={{mt: {xs: 4, sm: 7}, fontWeight: 600}}
                fullWidth
                onClick={() => formik.handleSubmit()}>
          Continue
        </Button>
      </motion.div>
    </>
  );
};
